import {User} from "@/services/user";
import {createStore} from "@/utils/store";


export interface AppState {
  appTitle: String,
  user: User,
  transactionId: string,
  pendingApprovals?: number
}

export const AppStore = createStore<AppState>()
